module.exports = __webpack_public_path__ + "resources/triangle-3abbac9b397afe95ac44bd82290937f0.svg";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/triangle.svg
// module id = 69
// module chunks = 0